// @ts-nocheck
/**
 * Parallax Scrolling with GSAP + ScrollTrigger
 *
 * Global dependencies (loaded via CDN in theme.liquid):
 * - gsap: GreenSock Animation Platform
 * - ScrollTrigger: GSAP ScrollTrigger plugin
 */

document.addEventListener("DOMContentLoaded", () => {
  // Respect user's motion preferences (accessibility)
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  // Register ScrollTrigger plugin
  gsap.registerPlugin(ScrollTrigger);

  // Find all parallax containers
  let parallaxWrappers = document.querySelectorAll("[data-parallax-wrapper]");

  // Add ready class for entrance animations
  document.documentElement.classList.add("parallax-ready");

  // Exit if no parallax wrappers found
  if (!parallaxWrappers.length) {
    return;
  }

  // Setup responsive behavior
  let mm = gsap.matchMedia();
  let breakPoint = 1024;

  mm.add(
    {
      isDesktop: `(min-width: ${breakPoint}px)`,
      isMobile: `(max-width: ${breakPoint - 1}px)`
    },
    (context) => {
      // Loop through each parallax wrapper
      parallaxWrappers.forEach((wrapper) => {
        // Find all elements with data-parallax attribute
        let parallaxItems = wrapper.querySelectorAll("[data-parallax]");

        if (parallaxItems.length) {
          parallaxItems.forEach((el) => {
            // Get parallax amount from data attribute
            const parallaxAmount = parseInt(el.dataset.parallax, 10);

            // Validate parsed value - skip element if invalid
            if (Number.isNaN(parallaxAmount)) {
              console.warn('Invalid parallax value for element:', el, 'data-parallax:', el.dataset.parallax);
              return; // Skip this element
            }

            // Clamp parallax value to reasonable range (-500 to 500)
            let clampedAmount = Math.max(-500, Math.min(500, parallaxAmount));
            if (el.hasAttribute("data-parallax-direction")) {
              const parallaxDirection = el.getAttribute("data-parallax-direction");
              if (parallaxDirection === "down") {
                clampedAmount = -clampedAmount;
              }
            }
            // Check if desktop-only parallax
            const desktopOnly = el.hasAttribute("data-parallax-lg");

            // Apply parallax only if conditions met
            if (!desktopOnly || context.conditions.isDesktop) {
              gsap.fromTo(
                el,
                {
                  y: clampedAmount // Starting position
                },
                {
                  y: -clampedAmount, // Ending position
                  scrollTrigger: {
                    trigger: wrapper, // Container that triggers animation
                    start: "top bottom", // Start when wrapper top hits viewport bottom
                    end: "bottom top", // End when wrapper bottom hits viewport top
                    scrub: true // Smooth animation tied to scroll
                  },
                  ease: "none" // Linear movement
                }
              );
            }
          });
        }
      });
    }
  );
});
